import { Skeleton, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

const Row = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr 1fr 1.5fr 1.5fr;
  padding: 25px 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`

const Cell = styled.div`
  display: flex;
  align-items: center;
`

/** Shimmer rows matching the pools/liquidity table grid. */
export const TableRowsSkeleton = ({ rows = 6 }: { rows?: number }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Row key={i}>
        <Cell style={{ gap: 12 }}>
          <Skeleton variant="circle" width={32} height={32} />
          <Skeleton width={110} height={16} />
        </Cell>
        <Cell><Skeleton width={72} height={16} /></Cell>
        <Cell><Skeleton width={72} height={16} /></Cell>
        <Cell><Skeleton width={64} height={16} /></Cell>
        <Cell><Skeleton width={90} height={16} /></Cell>
        <Cell style={{ justifyContent: 'flex-end', gap: 8 }}>
          <Skeleton variant="circle" width={40} height={40} />
          <Skeleton width={84} height={36} borderRadius={12} />
        </Cell>
      </Row>
    ))}
  </>
)

const Card = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background: ${({ theme }) => theme.colors.backgroundAlt};
  border-radius: 24px;
  padding: 24px;
  width: 100%;
  max-width: 350px;
  align-self: baseline;
  box-shadow: 0 16px 40px -16px rgba(0, 0, 0, 0.6);
`

/** Shimmer cards matching the farm/pool card layout. */
export const CardSkeleton = () => (
  <Card>
    <Flex alignItems="center" style={{ gap: 12 }} mb="20px">
      <Skeleton variant="circle" width={48} height={48} />
      <Skeleton width={120} height={20} />
    </Flex>
    <Flex justifyContent="space-between" mb="20px">
      <div>
        <Skeleton width={50} height={14} mb="8px" />
        <Skeleton width={80} height={18} />
      </div>
      <div>
        <Skeleton width={50} height={14} mb="8px" />
        <Skeleton width={80} height={18} />
      </div>
    </Flex>
    <Skeleton width="100%" height={1} mb="20px" />
    <Skeleton width={90} height={14} mb="8px" />
    <Skeleton width={140} height={20} mb="20px" />
    <Skeleton width="100%" height={48} borderRadius={12} />
  </Card>
)

export const CardGridSkeleton = ({ cards = 6 }: { cards?: number }) => (
  <Flex flexWrap="wrap" justifyContent="center" style={{ gap: 24 }} width="100%">
    {Array.from({ length: cards }).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <CardSkeleton key={i} />
    ))}
  </Flex>
)
